import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React, {useEffect, useState} from "react";
import ConditionalComponent from "../../Shared/ConditionalComponent";
import {AiIcon, AiIconHover} from "../../../assets/svg-icons/AiIcon";
import Tooltip from '@mui/material/Tooltip';

export const AiButton = observer(({}) => {
    const {generalStore, aiStore} = useStores();
    const [hovered, setHovered] = useState(false);
    const handleOpen = async ()=>{
        aiStore.isChatOpen = true
        await aiStore.sendInitialValues(window.location.href, aiStore.sendMessageToIframe,false, generalStore.workspace)
    }
    return (
        <ConditionalComponent
            if={generalStore?.domainSettings?.IsSupportAIChatWebEnabled && generalStore?.userDetails?.Name && generalStore.hasAiChatAccess }>

            <div className="relative group" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
                 onClick={handleOpen}
                 style={{cursor: 'pointer'}}>
                <Tooltip
                    title={'Open AI Chat'}
                    placement="right"


                    slotProps={{
                        popper: {
                            modifiers: [
                                {
                                    name: 'offset',
                                    options: {
                                        offset: [0, -8],
                                    },
                                },
                            ],
                        },
                        tooltip: {
                            className: "!text-[16px] !text-main-normal !bg-background-normal !border !border-nav-normal !shadow-lg !rounded-input !font-normal",
                        }
                    }}>
                    <div className={`p-1 opacity-${hovered ? '0' : '100'}`}>
                        <AiIcon/>
                    </div>
                    <div className={`absolute inset-0 opacity-${!hovered ? '0' : '100'}`}>
                        <AiIconHover/>

                    </div>
                </Tooltip>
            </div>
        </ConditionalComponent>
    )
});